(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[133],{

/***/ 9559:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[handle]/[articleHandle]",
      function () {
        return __webpack_require__(35114);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Article; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31373);
/* harmony import */ var theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70863);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _templates_article__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61139);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93183);
/* eslint-disable import/no-unresolved */ 







var __N_SSG = true;
function Article(_param) {
    var isPreview = _param.isPreview, renderSections = _param.renderSections, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "isPreview",
        "renderSections"
    ]);
    var article = props.article;
    var setArticle = _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__.store.recoil.useRecoilState(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__.store.state.article)[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setArticle(article);
    }, [
        article === null || article === void 0 ? void 0 : article.handle
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components__WEBPACK_IMPORTED_MODULE_4__/* .PageErrorBoundary */ .bg, {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components__WEBPACK_IMPORTED_MODULE_4__/* .PageHead */ .yG, {
            page: article,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_templates_article__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
                renderSections: renderSections
            }))
        })
    });
}


/***/ }),

/***/ 61139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ article; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ./src/templates/blog/BlogNav/BlogNav.jsx + 4 modules
var BlogNav = __webpack_require__(47207);
;// CONCATENATED MODULE: ./src/templates/blog/BlogNav/index.js


// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
;// CONCATENATED MODULE: ./src/templates/article/Header/Header.theme.js

var themed = (0,create/* create */.U)(new function() {
    this.date = {
        variant: "text.base"
    };
    this.title = {
        variant: "text.h2",
        textAlign: "center",
        mt: 12,
        mb: 12
    };
    this.articleHero = {
        maxHeight: [
            275,
            580
        ],
        width: "100%",
        objectFit: "cover",
        mt: 13
    };
}());

;// CONCATENATED MODULE: ./src/templates/article/Header/Header.jsx




var Header = themed(function(param) {
    var title = param.title, author = param.author, date = param.date, image = param.image, theme = param.theme;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Header.displayName,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                variant: "flex.column.center.center",
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: theme.date,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                        children: [
                            author,
                            " | ",
                            date
                        ]
                    })
                })
            }),
            title && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h1",
                sx: theme.title,
                children: title
            }),
            image && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
                alt: "Blog article image",
                src: image,
                sx: theme.articleHero
            })
        ]
    });
});
Header.displayName = "Header";

;// CONCATENATED MODULE: ./src/templates/article/Header/index.js


// EXTERNAL MODULE: ./src/snippets/index.js + 362 modules
var snippets = __webpack_require__(61653);
;// CONCATENATED MODULE: ./src/templates/article/Content/Content.theme.js

var Content_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        mt: [
            12,
            17
        ]
    };
    this.markdown = {
        variant: "text.base",
        mx: "auto",
        maxWidth: 840
    };
    this.html = {
        mx: "auto",
        maxWidth: 840,
        variant: "text.base",
        table: {
            width: "100%"
        },
        thead: {
            backgroundColor: "lightgrey"
        },
        "th, td": {
            py: "5px"
        },
        "tr:nth-of-type(even)": {
            backgroundColor: "#f5f5f5"
        },
        p: {
            mb: 8,
            fontFamily: "body"
        },
        "ul, ol": {
            mb: 8,
            pl: 13
        },
        ul: {
            li: {
                listStyleType: "disc"
            }
        },
        ol: {
            li: {
                listStyleType: "decimal"
            }
        },
        li: {
            mb: 4,
            listStylePosition: "inside",
            textIndent: "-22px",
            fontFamily: "body"
        },
        a: {
            textDecoration: "underline",
            fontFamily: "body"
        },
        h1: {
            variant: "text.h1",
            mb: 11
        },
        h2: {
            variant: "text.h2",
            mt: 11,
            mb: 10
        },
        h3: {
            variant: "text.h3",
            mt: [
                9,
                null,
                11
            ],
            mb: 9
        },
        h4: {
            variant: "text.h4",
            mb: 9
        },
        h5: {
            variant: "text.h5",
            mb: 9
        },
        h6: {
            variant: "text.h6",
            mb: 9
        },
        "span, del": {
            textDecorationColor: "currentColor"
        },
        strong: {
            fontWeight: "700 !important"
        }
    };
}());

;// CONCATENATED MODULE: ./src/templates/article/Content/Content.jsx




var Content = Content_theme_themed(function(param) {
    var body = param.body, bodyHtml = param.bodyHtml, theme = param.theme;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        variant: "layout.padded",
        sx: theme.wrapper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            sx: theme.body,
            children: bodyHtml ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.html,
                dangerouslySetInnerHTML: {
                    __html: bodyHtml
                }
            }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                textSx: theme.markdown,
                text: body
            })
        })
    });
});

;// CONCATENATED MODULE: ./src/templates/article/Content/index.js


;// CONCATENATED MODULE: ./src/templates/article/article.jsx
/* eslint-disable react/prop-types */ 







function ArticleTemplate(param) {
    var renderSections = param.renderSections;
    var ref;
    var article = (0,dist.useArticle)();
    var ref1 = (0,_object_spread/* default */.Z)({}, article), title = ref1.title, image = ref1.image, author = ref1.author, body = ref1.body, bodyHtml = ref1.bodyHtml, _createdAt = ref1._createdAt, createdAt = ref1.createdAt;
    var date = (0,react.useMemo)(function() {
        var ref = (0,_sliced_to_array/* default */.Z)(new Date(Date.parse(_createdAt || createdAt)).toString().split(" "), 4), month = ref[1], day = ref[2], year = ref[3];
        return "".concat(month, " ").concat(day, ", ").concat(year);
    }, [
        _createdAt,
        createdAt
    ]);
    var jpg = (0,react.useMemo)(function() {
        return bodyHtml === null || bodyHtml === void 0 ? void 0 : bodyHtml.slice(bodyHtml.indexOf("cdn"), bodyHtml.indexOf(".jpg"));
    }, [
        bodyHtml
    ]);
    var png = (0,react.useMemo)(function() {
        return bodyHtml === null || bodyHtml === void 0 ? void 0 : bodyHtml.slice(bodyHtml.indexOf("cdn"), bodyHtml.indexOf(".png"));
    }, [
        bodyHtml
    ]);
    var srcUrl = (jpg === null || jpg === void 0 ? void 0 : jpg.length) < 200 ? jpg : png;
    var extension = (jpg === null || jpg === void 0 ? void 0 : jpg.length) < 200 ? ".jpg" : ".png";
    var fallbackContentImage = image || (jpg || png ? "https://".concat(srcUrl).concat(extension) : "https://cdn.shopify.com/s/files/1/1114/2308/files/brumate-blog-placeholder.jpg");
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": "ArticleTemplate",
        variant: "layout.content",
        sx: {
            maxWidth: [
                1024,
                1280
            ],
            margin: "0 auto",
            py: [
                14,
                18
            ]
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Header, {
                title: title || (article === null || article === void 0 ? void 0 : (ref = article.seo) === null || ref === void 0 ? void 0 : ref.title),
                author: author,
                date: date,
                image: bodyHtml ? image || fallbackContentImage : null
            }),
            renderSections(),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Content, {
                body: body,
                bodyHtml: bodyHtml
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/templates/article/index.js

/* harmony default export */ var article = (ArticleTemplate);


/***/ }),

/***/ 47207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ BlogNav; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ./src/utils/index.js + 7 modules
var utils = __webpack_require__(39136);
// EXTERNAL MODULE: ./src/snippets/index.js + 362 modules
var snippets = __webpack_require__(61653);
// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
;// CONCATENATED MODULE: ./src/templates/blog/BlogNav/Header/Header.theme.js

var themed = (0,create/* create */.U)(new function() {
    this.header = {
        display: "flex",
        width: [
            "fit-content",
            "100%"
        ],
        flexDirection: "column"
    };
    this.heading = {
        variant: "text.h1",
        flex: 1,
        mx: [
            10,
            8
        ]
    };
}());

;// CONCATENATED MODULE: ./src/templates/blog/BlogNav/Header/Header.jsx







var Header = themed(function(param) {
    var theme = param.theme, text = param.text;
    var headingText = (text === null || text === void 0 ? void 0 : text.heading) || "# Blog";
    var justifyContentArr = [
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignment),
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignment),
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignmentDt),
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignmentDt), 
    ];
    var alignItemsArr = [
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignment),
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignment),
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignmentDt),
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignmentDt), 
    ];
    var textAlignArr = [
        text === null || text === void 0 ? void 0 : text.alignment,
        text === null || text === void 0 ? void 0 : text.alignment,
        text === null || text === void 0 ? void 0 : text.alignmentDt,
        text === null || text === void 0 ? void 0 : text.alignmentDt, 
    ];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Header.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.header), {
            justifyContent: justifyContentArr,
            alignItems: alignItemsArr
        }),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
            textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                textAlign: textAlignArr
            }),
            children: headingText
        })
    });
});
Header.displayName = "Header";

;// CONCATENATED MODULE: ./src/templates/blog/BlogNav/Header/index.js


;// CONCATENATED MODULE: ./src/templates/blog/BlogNav/BlogNav.theme.js

var BlogNav_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        minHeight: 56,
        py: [
            6,
            8
        ],
        px: 8
    };
    this.header = {
        mb: [
            "12px",
            "16px"
        ]
    };
    this.scroll = {
        flexWrap: [
            "noWrap",
            "wrap"
        ],
        justifyContent: [
            "flex-start",
            "center"
        ],
        width: "100%",
        height: "100%",
        overflowY: "hidden",
        overflowX: "auto",
        whiteSpace: "nowrap",
        webkitOverflowScrolling: "touch",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        pb: 3,
        "::-webkit-scrollbar": {
            display: "auto"
        }
    };
    this.link = {
        mb: [
            0,
            3
        ],
        variant: "text.label.1",
        minWidth: "auto",
        height: 32,
        px: 11,
        bg: "gray",
        lineHeight: 32,
        whiteSpace: "nowrap",
        borderRadius: 16,
        cursor: "pointer",
        transition: "background-color 0.2s ease-in-out",
        ":hover": {
            bg: "mediumGray"
        }
    };
}());

;// CONCATENATED MODULE: ./src/templates/blog/BlogNav/BlogNav.jsx









var BlogNav = BlogNav_theme_themed(function(param) {
    var theme = param.theme, _articlePage = param.articlePage, articlePage = _articlePage === void 0 ? false : _articlePage;
    var settings = (0,dist.useSettings)();
    var text = ((settings === null || settings === void 0 ? void 0 : settings.blogSettings) || {}).text;
    var blog = (0,dist.useBlog)();
    var router = (0,dist.useRouter)();
    var categories = (0,react.useMemo)(function() {
        var ref;
        if (!(blog === null || blog === void 0 ? void 0 : (ref = blog.articles) === null || ref === void 0 ? void 0 : ref.length)) return [];
        var articleCategories = blog === null || blog === void 0 ? void 0 : blog.articles.map(function(value, index) {
            if (value.category !== "") return value.category;
        });
        return (0,_to_consumable_array/* default */.Z)(new Set((0,_to_consumable_array/* default */.Z)((articleCategories === null || articleCategories === void 0 ? void 0 : articleCategories.filter(function(category) {
            return category;
        })) || [])));
    }, [
        blog === null || blog === void 0 ? void 0 : blog.articles
    ]);
    var activeCategoryLink = (0,react.useMemo)(function() {
        if (!router.query.category) {
            return "All";
        }
        return categories === null || categories === void 0 ? void 0 : categories.find(function(category) {
            return category === router.query.category;
        });
    }, [
        router.query.category
    ]);
    var handleClick = (0,react.useCallback)(function(categorySelected) {
        var item = categories === null || categories === void 0 ? void 0 : categories.find(function(category) {
            return category === categorySelected;
        });
        var encoded = encodeURIComponent(item);
        var link = "articles/".concat(categorySelected === "All" ? "" : "?category=".concat(encoded));
        articlePage ? router.replace("/blogs/".concat(link)) : router.push(link, undefined, {
            shallow: true
        });
    });
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        sx: theme.wrapper,
        children: [
            !articlePage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.header,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Header, {
                    text: text
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.scroll,
                children: categories && [
                    "All"
                ].concat((0,_to_consumable_array/* default */.Z)(categories)).map(function(category, index, arr) {
                    if (!category) return null;
                    var isActive = category === activeCategoryLink;
                    var rightMargin = index !== arr.length - 1 ? 3 : 0;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                        variant: "buttons.plain",
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.link), {
                            mr: rightMargin,
                            bg: isActive ? "mediumGray" : theme.link.bg
                        }),
                        onClick: function() {
                            return handleClick(category);
                        },
                        children: category
                    }, index);
                })
            })
        ]
    });
});
BlogNav.displayName = "BlogNav";


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(9559); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);